import Cel from "../images/celulares.png";
import Com from "../images/Comida.png";
import Ene from "../images/Energia.png";
import Men from "../images/Menu.png";
import Mod from "../images/Moda.png";
import Mueb from "../images/Muebles.png";
import Neg from "../images/NegocioIMG.png";
import Teg from "../images/tecnologia.png";
import Res from "../images/Restaurante.png";

export const cardsData = [
  {
    title: "Telefonía 📱",
    text: "¿Vendes telefonía o accesorios? ¡Necesitas esta página web! Incrementa la confianza a tus clientes.",
    link: "https://marcogrimaldo.github.io/cat-griza/pomato/index.html",
    img: Cel
  },
  {
    title: "Comida 🍝",
    text: "¿Preparas alimentos? ¡Necesitas esta página web! Dale toda la información a tus clientes.",
    link: "https://marcogrimaldo.github.io/cat-griza/king-of-pasta/index.html",
    img: Com
  },
  {
    title: "Energía ⚡",
    text: "¿Tu negocio es tradicional? ¡Necesitas esta página web! Pon tu negocio en la web para ser completamente formal.",
    link: "https://marcogrimaldo.github.io/cat-griza/2092_shelf/index.html",
    img: Ene
  },
  {
    title: "Menú 🍱",
    text: "¡Ahorra en papel! Y que el cátalogo o menú de tu negocio esté en la Web.",
    link: "https://marcogrimaldo.github.io/cat-griza/templatemo_539_simple_house/index.html",
    img: Men
  },
  {
    title: "Moda 💃",
    text: "¿Vendes accesorios de moda o ropa? ¡Necesitas esta página web! Da el siguiente paso en tu emprendimiento.",
    link: "https://marcogrimaldo.github.io/cat-griza/2114_pixie/index.html",
    img: Mod
  },
  {
    title: "Muebles 🪑",
    text: "Si los muebles y carpintería es lo tuyo, definitivamente necesitas esta página web.",
    link: "https://marcogrimaldo.github.io/cat-griza/niture/index.html",
    img: Mueb
  },
  {
    title: "Negocio 💲",
    text: "Haz crecer tu negocio con esta página web, tus clientes tendrán más confianza y podrán conocer más de tus productos.",
    link: "https://marcogrimaldo.github.io/cat-griza/templatemo_546_sixteen_clothing/index.html",
    img: Neg
  },
  {
    title: "Restaurante 🌮",
    text: "¿Preparas alimentos? ¡Necesitas esta página web! Dale toda la información a tus clientes.",
    link: "https://marcogrimaldo.github.io/cat-griza/bootstrap-restaurant/index.html",
    img: Teg
  },
  {
    title: "Productos 📺",
    text: "Consigue que tus clientes vean todos los productos que vendes y verder mucho más.",
    link: "https://marcogrimaldo.github.io/cat-griza/pcoint/index.html",
    img: Res
  },
];